import {ExtensionsSettingsSubspaceState} from '~src/app/spaces/SiteSettingsSpace/ExtensionsSettingsSubspace';
import {componentRegistryEntry} from '~src/settings/general-settings/components/SettingsComponentRegistryFunctions';
import {SettingsSection} from '~src/settings/components/common/SettingsSection';
import React = require('react');
import {Messages} from '~src/codegen/Localize';
import {FormikCheckbox} from '~commonInfra/components/FormikCheckbox';
import {
TextLinkWidget
} from '@tableau/widgets';
import {AnalyticsExtensionsSettingsSubFormikProps} from '~src/settings/general-settings/components/extensions-settings/ExtensionsSettingsCoordinator';
import {learnMoreStyle} from '~src/settings/styles/CommonStyles';
import {HelpService} from '~commonInfra/services/HelpService';
import {ServerSettingsInstance} from '~src/settings/services/ServerSettings';

export function AnalyticsExtensionsServerSection(props: AnalyticsExtensionsSettingsSubFormikProps) {

  return (
    <SettingsSection title={Messages.analyticsExtensionsSettings_header()}
                     description={renderDescription()}>
      <FormikCheckbox
        name="settings.analyticsExtensionsServerSettings.enabled"
        testId="anext_site_enable_checkbox"
        label={Messages.analyticsExtensionsSettingsServer_checkbox()}
      />
    </SettingsSection>
  );
}

function renderDescription() {
  return (
    <div>
      {Messages.analyticsExtensionsSettingsServer_description()}
      <TextLinkWidget testId={'analytics-extensions-server-settings-description'}
                      target={'_blank'}
                      className={learnMoreStyle}
                      href={HelpService.getServerHelpUrlByCategory('analytics_extension')}>
        {Messages.learnMore()}
      </TextLinkWidget>
    </div>
  );
}
export const AnalyticsExtensionsServerSectionSpec = componentRegistryEntry({
  name: 'AnalyticsExtensionsServerSection',
  component: AnalyticsExtensionsServerSection,
  onSubmit: async (settings: ExtensionsSettingsSubspaceState) => {
    await Promise.all([ServerSettingsInstance.updateAnalyticsExtensionsServerSettings(settings.analyticsExtensionsServerSettings)]);
  },
});
